import { CircularProgress, Typography } from '@mui/material';
import React from 'react';

export default function ErrorScreen({ error }) {
    return (
        <div style={{ width: '95vw', height: '60vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Typography>{error?.response?.data?.message || error?.response?.data || error?.message}</Typography>
        </div>
    );
}
